<template>
    <div class="quickpay-error">
        <div class="quickpay-error__content">
            <QuickpayPaymentOverviewDescription type="error" class="quickpay-error__description" />
        </div>
        <FooterPoweredBySellsy v-if="hasQuickpayV2PoweredSellsyFeature" />
    </div>
</template>

<script>
import QuickpayPaymentOverviewDescription from 'vcomponents/quickpay/payment/QuickpayPaymentOverviewDescription.vue';
import FooterPoweredBySellsy from 'vcomponents/common/FooterPoweredBySellsy.vue';
import Feature from 'Services/Feature';

export default {
    components: {
        QuickpayPaymentOverviewDescription,
        FooterPoweredBySellsy,
    },
    computed: {
        hasQuickpayV2PoweredSellsyFeature() {
            return Feature.isEnabled('quickpay-v2-powered-by-sellsy');
        },
    },
};
</script>

<style lang="scss">
.global:has(.quickpay-error) {
    min-width: 0 !important;
}
#contentDiv.has-sidebar-closed:has(.quickpay-error) {
    padding: 0 !important;
}
#contentDiv:has(.quickpay-error) .contentMargin {
    height: auto;
}
</style>

<style lang="scss" scoped>
.quickpay-error {
    min-height: 100vh;
    min-height: 100dvh;
    background: url(../ressources/logged/img/illustrations/payment/background-payment.png) center
        center/cover no-repeat;
    display: flex;
    flex-direction: column;
    padding: var(--spacing-5);
    animation: fadeIn 0.5s ease-out;

    @media (max-width: 1023px) {
        background-image: url(../ressources/logged/img/illustrations/payment/background-payment-mobile.png);
        padding: var(--spacing-4);
    }

    &__content {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: 68px;
    }

    &__description {
        max-width: 500px;
        text-align: center;
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}
</style>
